import { Link, useLocation } from "react-router-dom";
import style from "./ModalAppsItem.module.css";

function TopbarItem({ texto, link, logo }) {
  const location = useLocation();
  const linkAtivo = location.pathname.startsWith(link); // Verifica se a URL atual corresponde ao link do item

  return (
    <Link
      to={link}
      className={`${style.topbar_item} ${linkAtivo ? style.link_ativo : ""}`}
    >
      {logo}
      <h3 className={style.texto_link}>{texto}</h3>
    </Link>
  );
}

export default TopbarItem;
